import { z } from 'zod';
import { baseTaskSchema } from '../schema.base.js';
import { checkboxMediaInput } from '../select-answers.checkbox/input.media.js';

const selectAnswersRadioButtonTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("SelectAnswers"),
  answerType: z.literal("RadioButton"),
  answerOptions: z.array(checkboxMediaInput.schema).optional().default([]),
  settings: z.object({
    orientation: z.enum(["Vertical", "Horizontal"]).catch("Vertical").default("Vertical")
  }).default({
    orientation: "Vertical"
  })
}).transform(({
  answerOptions,
  ...rest
}) => ({
  ...rest,
  content: answerOptions.map((it, index) => checkboxMediaInput.postprocessSchemaInput(it, {
    taskId: rest.id,
    index
  }))
}));

export { selectAnswersRadioButtonTaskSchema };
//# sourceMappingURL=_schema.js.map
